import http from "../jslibs/axios/http";

// 课程订单列表
export const courseOrderList = (data) => http.get("/v1/cms/courseOrder", data);
// 订单详情
export const courseOrderDetail = (uuid) => http.get(`/v1/cms/courseOrder/${uuid}`);
// // 订单操作
export const courseOrderEdit = (data, uuid) => http.put(`/v1/cms/CourseOrder/${uuid}`, data);
// 导出
export const CourseOrderExport = (data) => http.down("/v1/cms/CourseOrderExport", data);
// 商品订单
// 快递列表
export const getShipCompany = (data) => http.get("/v1/cms/ShipCompany", data);
// 订单列表
export const GoodsOrderList = (data) => http.get("/v1/cms/GoodsOrder", data);
export const GoodsOrderExport = (data) => http.down("/v1/cms/GoodsOrderExport", data);
// 订单详情
export const GoodsOrderDetail = (uuid) => http.get(`/v1/cms/GoodsOrder/${uuid}`);
// // 订单操作
export const GoodsOrderEdit = (data, uuid) => http.put(`/v1/cms/GoodsOrder/${uuid}`, data);
// // 分类
// export const getLiveType = data => http.get('/v1/cms/cate', data)
// // 新增直播
// export const addLive = data => http.post(`/v1/cms/live`, data)

// // 删除直播
// export const deleteLive = uuid => http.delete(`/v1/cms/Live/${uuid}`)
// // 置顶取消
// export const setTopLive = uuid => http.get(`/v1/cms/LiveTop/${uuid}`)
// // 上下架
// export const LiveStatus = uuid => http.get(`/v1/cms/LiveStatus/${uuid}`)
// 培训计划上传
export const OrderTrainUp = (data) => http.post(`/v1/cms/OrderTrain`, data);
